'use client'

import { useLocale } from '~/contexts/LocaleContext'
import { getTranslation } from '~/lib/i18n-utils'
import { Image } from '~/components/ui/image'

export default function Loading() {
  const { locale } = useLocale()
  const t = getTranslation(locale)
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center overflow-hidden bg-gradient-to-br from-white via-gray-50 to-gray-100 transition-colors dark:from-gray-900 dark:to-gray-800">
      <div className="animate-fade-in text-center">
        <div className="mb-6">
          <Image
            src="/static/images/logo-black.png"
            alt="Logo"
            className="mx-auto h-12"
            loading="eager"
          />
        </div>

        <div className="mb-6 flex items-center justify-center">
          <div className="h-12 w-12 animate-spin rounded-full border-4 border-primary-500 border-t-transparent"></div>
        </div>

        <h2 className="mb-2 text-2xl font-semibold text-gray-700 dark:text-gray-100">
          {t('common.loading')}
        </h2>
      </div>
    </div>
  )
}
